var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',_vm._g(_vm._b({staticClass:"pulse-checkbox",attrs:{"color":"#6366f1","hide-details":""},scopedSlots:_vm._u([(_vm.$slots.label)?{key:"label",fn:function(){return [_vm._t("label")]},proxy:true}:null],null,true)},'v-checkbox',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }